import { VisionFilterKeyVO as BaseVisionFilterKeyVO } from '@wizeoo/akm-compute-lib';
import { ChronocodeVO } from '../core/chronocode.vo';
import { FreeDataVO } from '../core/freedata.vo';
import { VisionFilterKey } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { ViewData } from '../../model/view.data';

export class VisionFilterKeyVO extends BaseVisionFilterKeyVO {

  constructor(model: Model, pSource: VisionFilterKey) {
    super(model, pSource);
  }

  protected get model(): Model {
    return this._model as Model;
  }
  protected set model(value: Model) {
      this._model = value;
  }

  public get order(): number {
    return this.source.order;
  }

  private _splittedCode: string[];

  public get splittedCode(): string[] {
    if (!this._splittedCode) {
      this._splittedCode = this.code.split(ViewData.CONTEXT_SEPARATOR);
    }

    return this._splittedCode;
  }

  /* ############################################
   *       Collecte des VOs
   * ############################################ */

  // [MOTEUR BACK] On récupére ici des instances "ihm"
  public override getRelatedFd(): FreeDataVO {
    return super.getRelatedFd() as FreeDataVO;
  }

  public override getRelatedChrono(): ChronocodeVO {
    return super.getRelatedChrono() as ChronocodeVO;
  }

  /* ################################################
                    Accesseurs composites
  ################################################ */

  /** retourne le code pour les chronos ou les FDs */
  public get dataKeyAllTheWays(): string {
    if (this.isFD) {
      return this.getRelatedFd().code;
    } else {
      return null;
    }
  }

  /**
   * Accés simplifié au label traduit à partir de la locale en cours d'utilisation dans l'appli
   */
  public get trsLabel(): string {
    return this.model.visionEngine.getKeyLabel(this);
  }
}
